import Button from '@/components/Button';
import ErrorMessage from '@/components/Form/ErrorMessage';
import FormGroup from '@/components/Form/FormGroup';
import InputText from '@/components/Input/InputText';
import { H3 } from '@/components/Titles';
import { breakpoint } from '@/helpers/BreakpointHelper';
import React, { FC, useCallback } from 'react';
import { useForm, SubmitHandler } from 'react-hook-form';
import styled from 'styled-components';
import { useUserStore } from '@/stores/UserStore';
import { usePopupStore } from '@/stores/PopupStore';
import { MyGoodHundredControllerService } from '@/__generated__/FrontApi';
import { isMobileDevice } from '@/helpers/BrowserHelper';

const Container = styled.div`
  max-width: 544px;
  margin: 0 auto;
  padding-top: 104px;
  text-align: center;
  ${breakpoint(`mobile`)} {
    padding-top: 95px;
  }

  ${H3} {
    margin-bottom: 16px;
    line-height: 1.7;
    ${breakpoint(`mobile`)} {
      font-size: 14px;
      line-height: 2;
    }
  }
  ${Button} {
    margin: 0;
  }
`;

interface MyPageSupportHistoryTab3Props {
  params?: URLSearchParams;
}
export interface FormData {
  approvalNumber: string;
}

const MyPageSupportHistoryTab3: FC<MyPageSupportHistoryTab3Props> = () => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<FormData>({
    defaultValues: {
      approvalNumber: ``,
    },
  });
  const userStore = useUserStore();
  const popupStore = usePopupStore();

  const onSubmit: SubmitHandler<FormData> = useCallback(
    async (formData) => {
      const {
        data,
        resultCode,
        resultMessage,
      } = await MyGoodHundredControllerService.matchApprovalNumber({
        ...formData,
        deviceType: isMobileDevice() ? `MOBILE` : `PC`,
      });
      if (resultCode === 'success') {
        popupStore.show(resultMessage || '후원이 완료되었습니다.');
        reset();
      } else {
        popupStore.show(
          resultMessage || '승인번호 조회 중 오류가 발생했습니다.',
        );
      }
    },
    [userStore.user?.donorId],
  );
  return (
    <Container>
      <H3>
        CU 착한기부 후원 하셨나요? <br />
        후원내역 조회를 위해 승인 번호를 입력해 주세요.
      </H3>
      <form onSubmit={handleSubmit(onSubmit)}>
        <FormGroup>
          <InputText
            placeholder="승인번호를 입력해 주세요."
            ref={register({
              required: {
                value: true,
                message: `승인번호를 입력해 주세요.`,
              },
              minLength: {
                value: 3,
                message: `3자 이상 입력해주세요.`,
              },
              maxLength: {
                value: 20,
                message: `20자 이하로 입력해주세요.`,
              },
            })}
            name="approvalNumber"
            maxLength={20}
          />
          {errors.approvalNumber && (
            <ErrorMessage>{errors.approvalNumber.message}</ErrorMessage>
          )}
        </FormGroup>
        <Button full type="submit">
          확인
        </Button>
      </form>
    </Container>
  );
};

export default MyPageSupportHistoryTab3;
